import React from 'react'
import {fromYyyyMmDdLocal, toLocalYyyyMmDd} from '@common/utils/dates'

import {DatePicker} from '~/components/general/datePicker/DatePicker'

type Props = {
  value?: string
  required?: boolean
  onChange: (value?: string) => void
}

export const BookingDateInput: React.FC<Props> = ({
  value,
  required,
  onChange,
}) => (
  <DatePicker
    selected={fromYyyyMmDdLocal(value)}
    enableTwoDigitYearInput
    twoDigitYearPivot={2010}
    showMonthDropdown
    showYearDropdown
    dropdownMode="select"
    yearDropdownItemNumber={120}
    scrollableYearDropdown
    onChange={(date) => onChange(date ? toLocalYyyyMmDd(new Date(date)) : '')}
    required={!!required}
    inputProps={{inputMode: 'numeric'}}
  />
)
